import React, { useState } from 'react'
import { Form, Input } from 'antd'
// import CaptchaInput from './CaptchaInput'
import CaptchaImg from './CaptchaImg'
import { Link } from 'react-router-dom';
import IDasImageCaptcha from "./IDasImageCaptcha";
import SecondValidate from "./SecondValidate";

const LoginUserIcon = () => (
  <svg
    className="site-form-item-icon"
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="8" r="5" />
    <path d="M20 21a8 8 0 0 0-16 0" />
  </svg>
)

const LoginPasswordIcon = () => (
  <svg
    className="site-form-item-icon"
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="16" r="1" />
    <rect x="3" y="10" width="18" height="12" rx="2" />
    <path d="M7 10V7a5 5 0 0 1 10 0v3" />
  </svg>
)

const EyeIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
    <circle cx="12" cy="12" r="3" />
  </svg>
)

const EyeOffIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49" />
    <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242" />
    <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143" />
    <path d="m2 2 20 20" />
  </svg>
)

const NormalLoginForm = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const { refreshFidData, handleClick, captcha, captchaImg, captchaShow, redirectUrl, appid , form,requestId,
      secondValidateShow,secondValidateId,setLoginButtonDisabled,setLoadingText,
      IDasImage,IDasImageCode,IDasImageClick,IDasImageShow,setIDasImageShow} = props;
  return (
      <div>
        <Form
            form={form}
            name="normal_login"
            className="login-form"
            initialValues={{
              remember: true,
            }}
           // onFinish={onFinish}
        >
          <Form.Item label="企业账号" name="Phone" rules={[{required: true, message: '请输入账户！',}]} >
            <Input prefix={<LoginUserIcon />} placeholder="登录账号" />
          </Form.Item>
          <Form.Item label="密码" name="Password" rules={[{required: true, message: '请输入密码！',}]}
                     style={(IDasImageShow || captchaShow || secondValidateShow) ?{}:{marginBottom:0}}>
            <Input
                prefix={<LoginPasswordIcon />}
                suffix={
                  <button
                      className="password-toggle-icon"
                      type="button"
                      aria-label={showPassword ? "隐藏密码" : "显示密码"}
                      onMouseDown={(event) => event.preventDefault()}
                      onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                }
                type={showPassword ? "text" : "password"}
                placeholder="密码"
            />
          </Form.Item>
            {
                captchaShow ? <CaptchaImg handleClick={handleClick} captcha={captcha} captchaImg={captchaImg}/> : ""
            }
          {/*<CaptchaInput handleClick={handleClick} captcha={captcha} capRef={capRef}/>*/}
            {
                IDasImageShow ?
                    <IDasImageCaptcha handleClick={IDasImageClick} captcha={IDasImageCode} captchaImg={IDasImage}  style={secondValidateShow ? {}:{marginBottom:0}}/>:""
            }
            {
                secondValidateShow ? <SecondValidate  validateId={secondValidateId} form={form} refreshData={refreshFidData} refreshImageCode={IDasImageClick} IDasImageShow={IDasImageShow}
                                                      loading={setLoginButtonDisabled} loadingText={setLoadingText} imgCode={IDasImageCode} setIDasImageShow={setIDasImageShow}/>:""
            }

        </Form>
          <div className="forgot-password">
              <Link  to={`/password?redirect=${redirectUrl}&appid=${appid}&requestCid=${requestId}`}>忘记密码</Link>
          </div>

        {/*<div className="login-bottom">*/}
        {/*    <a>还没有账号？ 立即注册</a>*/}
        {/*</div>*/}
      </div>

  );
};

export default NormalLoginForm;
